import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { TableList } from '../../Tables';
import { Section } from '../../Section';
import { withLastValueFieldForm } from '../withLastValueFieldForm';
import { FieldLabel } from '../FieldLabel';
import { FieldBlock } from './partials';
export var FieldsTable = function FieldsTable(_ref) {
  var title = _ref.title,
    fields = _ref.fields,
    app = _ref.app,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    withFieldFormActions = _ref.withFieldFormActions;
  var rows = fields.map(function (field) {
    var value = field.lastValue ? field.lastValue.value : null;
    return {
      match: false,
      cells: [{
        params: {
          type: 'Column',
          textAlign: 'left'
        },
        component: React.createElement(FieldBlock, null, React.createElement("h4", null, field.field), React.createElement("div", null, field.description))
      }, {
        params: {
          type: 'Column',
          textAlign: 'right'
        },
        component: React.createElement(FieldLabel, {
          field: field,
          value: value,
          onEditAction: function onEditAction(editField) {
            withFieldFormActions.onEdit(editField);
          }
        }),
        onAction: function onAction() {
          withFieldFormActions.onEdit(field);
        }
      }]
    };
  });
  return React.createElement(Section, {
    title: title,
    size: "medium",
    bottomMargin: bottomMargin
  }, React.createElement(TableList, {
    fistColumnAsHeader: false,
    zebra: false,
    size: "small",
    rows: rows
  }));
};
export default withLastValueFieldForm(FieldsTable);